'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageBubble = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _arrayUtil = require('../../utils/arrayUtil');

var _MessageReceiptState = require('../../consts/MessageReceiptState');

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _ProgressSpinner = require('../ProgressSpinner');

var _ProgressSpinner2 = _interopRequireDefault(_ProgressSpinner);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Avatar = require('../Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMPTY = [];

/**
 * Message component.
 *
 * @param  {ReactElement} options.children
 * The message
 *
 * @param  {Boolean} options.mine
 * Was this message from "me"?
 *
 * @param {string} className
 * Additional class name to add.
 *
 * @param  {Boolean} options.animateEntrance
 * Should we animate the message when it mounts?
 *
 * @param  {string} options.name
 * Sender name - should only be used by "theirs".
 *
 * @param  {string} options.avatar
 * URL of the avatar to display, if any. Should also only be used for "theirs".
 *
 * @param  {string[]} options.seenBy
 * Array of picture URL's. Usually only used on the last message that was seen.
 *
 * @param {*} options.sentAt
 * Anything that can be parsed as a moment. If falsy, won't be displayed.
 *
 * @param {"SENDING" | "SENT" | "DELIVERED" | undefined} options.receiptState
 * When set, displays the correct indicator.
 *
 * @param  {object} options.style
 * A style object being applied on the bubble.
 *
 * @param {Function} onClick
 * The click handler for clicking on a bubble.
 */
var Message = function Message(_ref) {
  var children = _ref.children,
      className = _ref.className,
      animateEntrance = _ref.animateEntrance,
      mine = _ref.mine,
      name = _ref.name,
      avatar = _ref.avatar,
      seenBy = _ref.seenBy,
      sentAt = _ref.sentAt,
      receiptState = _ref.receiptState,
      style = _ref.style,
      onClick = _ref.onClick;

  seenBy = seenBy ? (0, _arrayUtil.toArray)(seenBy) : EMPTY;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('Message', {
        'Message--mine': mine,
        'Message--theirs': !mine,
        'Message--animate-entrance': animateEntrance
      }, className)
    },
    _react2.default.createElement(
      'div',
      { className: 'Message__gutter Message__gutter--left' },
      avatar && _react2.default.createElement(_Avatar2.default, { url: avatar, className: 'Message__sender-avatar' }),
      name && _react2.default.createElement(
        'div',
        { className: 'Message__sender-name' },
        name
      )
    ),
    _react2.default.createElement(
      'div',
      { onClick: onClick, className: 'Message__bubble-container' },
      _react2.default.createElement(
        'div',
        null,
        children,
        sentAt && _react2.default.createElement(
          'div',
          { className: 'Message__sent-timestamp' },
          'sent ',
          (0, _moment2.default)(sentAt).format('L LT')
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'Message__gutter Message__gutter--right' },
      !!mine && seenBy.length === 0 && _react2.default.createElement(ReceiptState, { receiptState: receiptState }),
      seenBy.map(function (s) {
        return _react2.default.createElement(_Avatar2.default, {
          className: 'Message__seen-by-avatar',
          key: s,
          url: s
        });
      })
    )
  );
};

Message.defaultProps = {
  onClick: _noop2.default
};

Message.propTypes = {
  children: _propTypes2.default.node,
  mine: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  avatar: _propTypes2.default.string,
  animateEntrance: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  seenBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  sentAt: _propTypes2.default.any,
  receiptState: _propTypes2.default.string,
  style: _propTypes2.default.object,
  onClick: _propTypes2.default.any
};

exports.default = Message;

/**
 * Indicates the status of the message.
 */

var ReceiptState = function ReceiptState(_ref2) {
  var receiptState = _ref2.receiptState;

  var sending = receiptState === _MessageReceiptState.SENDING;
  if (sending) {
    return _react2.default.createElement(_ProgressSpinner2.default, { blue: true, size: 12, thickness: 2 });
  }

  var sent = receiptState === _MessageReceiptState.SENT;
  var delivered = receiptState === _MessageReceiptState.DELIVERED;
  if (!sent && !delivered) {
    return false;
  }

  var icon = delivered ? 'check circle' : 'send';
  var title = delivered ? 'delivered' : 'sent';
  var color = delivered ? '#2395F3' : '#bbb';
  return _react2.default.createElement(_Icon2.default, { material: true, size: 12, name: icon, color: color, title: title });
};

ReceiptState.propTypes = {
  receiptState: _propTypes2.default.string
};

var MessageBubble = exports.MessageBubble = function MessageBubble(_ref3) {
  var style = _ref3.style,
      children = _ref3.children;
  return _react2.default.createElement(
    'div',
    { className: 'Message__bubble', style: style },
    _react2.default.createElement(
      'div',
      { className: 'Message__content' },
      children
    )
  );
};

MessageBubble.propTypes = {
  children: _propTypes2.default.node,
  style: _propTypes2.default.object
};
//# sourceMappingURL=Message.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Conversation/Message.js
// module id = 614
// module chunks = 0